import React, { lazy, Suspense } from "react";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { CssBaseline, responsiveFontSizes, Link } from "@mui/material";
import { green, red } from "@mui/material/colors";
import { withStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { UserProvider } from "./contexts/user.context";
import AppContent from "./AppContent";
import ComponentLoader from "./components/customComponents/component.loader";
// Lazy import
const CookieConsent = lazy(() =>
  import("./components/customComponents/cookie.consent")
);

// Global styles
const globalStyles = {
  "@global": {
    "input::-ms-reveal": { display: "none" },
    "input::-ms-clear": { display: "none" },
    "body::-webkit-scrollbar": { width: "10px", height: 8 },
    "body::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
    },
    "body::-webkit-scrollbar-thumb": {
      backgroundColor: "#43a047",
      outline: "1px solid slategrey",
    },
    body: {
      scrollbarWidth: "thin",
      scrollbarColor: "#43a047",
    },
  },
};

// Theme
const theme = responsiveFontSizes(
  createTheme({
    palette: {
      mode: "dark",
      primary: { main: green[600], contrastText: "#fff" },
      secondary: { main: red[600], contrastText: "#fff" },
      background: { default: "#303030" },
    },
    components: {
      MuiAppBar: {
        styleOverrides: { root: { backgroundColor: "green" } },
      },
      MuiDialogContent: {
        styleOverrides: { root: { backgroundColor: "#303030" } },
      },
      MuiCircularProgress: {
        styleOverrides: { root: { color: "#fff" } },
      },
    },
  })
);

// App
const App = () => {
  return (
    <UserProvider>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_ID_CLIENT_G}>
        <ThemeProvider theme={theme}>
          <Suspense fallback={<ComponentLoader />}>
            <CookieConsent
              cookieName="cookieConsent"
              message={
                <>
                  Questo sito utilizza cookie tecnici e di terze parti. Proseguendo nella navigazione accetti l’utilizzo dei cookie.
                  Qui di seguito trovi la{' '}
                  <Link href="/privacy" underline="always" color="inherit">
                    Informativa privacy
                  </Link>{' '}
                  e i{' '}
                  <Link href="/terms" underline="always" color="inherit">
                    Termini e Condizioni
                  </Link>
                  .
                </>
              }
              acceptButtonLabel="Chiudi"
            />
            <CssBaseline />
            <AppContent />
          </Suspense>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </UserProvider>
  );
};

export default withStyles(globalStyles)(App);
